import { Button } from './Button';
import { createSprite } from '../../../utils/GameEngine';
import Point = PIXI.Point;
import Container = PIXI.Container;

export class PriceButton extends Button {
    private coin: PIXI.Sprite;

    constructor(callback: () => any, price: number, parent?: Container, private notEnoughCoins: boolean = false, plus: boolean = false) {
        super('green_btn_small@2x', callback, ((plus) ? '+' : '') + price + '', true, true, 0.8, 32);
        if (parent) {
            parent.addChild(this);
        }
        this.updateLabelStatus(this.notEnoughCoins);
    }

    public disable(): void {
        this.interactive = false;
        this.buttonMode = false;
    }

    public enable(): void {
        this.interactive = true;
        this.buttonMode = true;
    }

    protected drawLayout(): void {
        super.drawLayout();
        this.coin = createSprite('coin_icon@2x', this);
        this.coin.anchor.set(0.5, 0.5);
        this.coin.scale.set(0.7, 0.7);
        this.coin.position.set(this.defaultSkin.width - this.coin.width / 2, this.defaultSkin.height / 2);
    }

    public updateLabel(text: string): void {
        super.updateLabel(text);
        this.label.anchor = new Point(1, 0);
        this.label.x = this.coin.x - this.coin.width * 0.5 - 5;
        this.label.y = (this.defaultSkin.height - this.label.height) / 2 - 5;
        if (this.notEnoughCoins !== undefined) {
            this.updateLabelStatus(this.notEnoughCoins);
        }
    }

    public updateLabelStatus(notEnoughCoins: boolean = false): void {
        if (notEnoughCoins) {
            this.label.style.fill = 0xFF0000;
            this.disable();
        } else {
            this.label.style.fill = 0xF7EDCA;
            this.enable();
        }
    }
}